/* eslint-disable react/no-array-index-key */

import React from 'react';

import TrackLinksWithin from 'core/analytics/TrackLinksWithin';
import { TTargetLinksCallback } from 'core/analytics/TrackLinksWithin/TrackLinksWithin';
import Image from 'core/sitecore/jss-proxy-components/JssImage';
import * as Typo from 'core/styles/Typography';
import {
	JssImageType,
	JssLinkType,
	JssTextType,
} from 'core/utils/sitecore-utils';
import CtaContainer from 'core/components/CtaContainer';
import Cta from 'core/components/Cta';

import * as S from './MessageBlock.style';

// Note: From Typo component
type TTextAlign =
	| 'center'
	| 'end'
	| 'justify'
	| 'left'
	| 'match-parent'
	| 'right'
	| 'start';

interface IMessageBlock {
	icon: JssImageType;
	title: JssTextType;
	subTitle: JssTextType;
	downloadText?: JssTextType;
	buttonLink: JssLinkType;
	headingAlign?: TTextAlign;
	bodyAlign?: TTextAlign;
	onButtonLinkClick?: () => void;
	onSubtitleClick?: () => void;
	targetLinks?: TTargetLinksCallback;
	isGreenId?: boolean;
}

const MessageBlock = ({
	icon,
	title,
	subTitle,
	buttonLink,
	headingAlign = 'center',
	bodyAlign = 'center',
	onButtonLinkClick,
	targetLinks,
	isGreenId,
}: IMessageBlock) => {
	return (
		<S.Wrapper>
			<Image field={icon} />
			<Typo.DisplayMedium
				margin="24px 0 0"
				textAlign={headingAlign}
				jss={title}
			/>
			{targetLinks ? (
				<TrackLinksWithin targetLinks={targetLinks}>
					<Typo.Body
						margin="16px 0 0"
						textAlign={bodyAlign}
						isRichText
						jss={subTitle}
					/>
				</TrackLinksWithin>
			) : (
				<Typo.Body
					margin="16px 0 0"
					textAlign={bodyAlign}
					isRichText
					jss={subTitle}
				/>
			)}

			<CtaContainer
				margin="16px 0 -12px"
				align="between"
				gap={32}
				disableFullWidth
			>
				{isGreenId ? (
					<>
						<Cta
							jssLink={buttonLink}
							onClick={onButtonLinkClick}
							ctaStyle="secondary"
							size="medium"
						/>
					</>
				) : (
					<Cta jssLink={buttonLink} onClick={onButtonLinkClick} />
				)}
			</CtaContainer>
		</S.Wrapper>
	);
};

export default MessageBlock;
